import { hasRequired } from '@app/features/apply-react-signing/libs/fieldTypeGuards';
import {
  CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST,
  CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS,
  CONTRACT_PROGRESS_FIELD_FOCUSED,
  CONTRACT_PROGRESS_TRACKER_NEXT_SEQUENCE,
} from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressTrackerTrackedFieldIdState = string | null;

const initialState: ContractProgressTrackerTrackedFieldIdState = null;

export default function reducer(
  state: ContractProgressTrackerTrackedFieldIdState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    case CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS: {
      const f = action.payload.fields
        .flatMap((f) => {
          if (f.type === 'AUTOFILL_GROUP') {
            return f.children;
          }
          return f;
        })
        .filter((v) => hasRequired(v.config) && v.config.required)
        .map((field) => {
          if (field.type === 'CHECKBOX_GROUP') {
            return field.children[0].id;
          }
          return field.id;
        });

      return f?.[0] ?? null;
    }
    case CONTRACT_PROGRESS_TRACKER_NEXT_SEQUENCE:
    case CONTRACT_PROGRESS_FIELD_FOCUSED:
      return action.payload;
    default:
      return state;
  }
}
